import helper from './helper'

const getWorkerUrlWithParameters = helper.getWorkerUrlWithParameters
const allowedWorkerOrderUrl = helper.allowedWorkerOrderUrl

export default {
  getWorkerUrlWithParameters,
  /**
   * Базовая функция для построения URL
   */
  getByRecievedUrlData: (url, gets = null) => getWorkerUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  WORKER: {
    ALLOWED: () => allowedWorkerOrderUrl(
      /**
       * Проверяет доступ к эндпоинту сотрудника
       * @returns {string} результат проверки доступа
       */
      'workers|employee|position|held-list',
      "list",
    ),
    POSITION_HELD_DETAIL:
      /**
       * Получает информацию о позициях сотрудника
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения информации о позициях
       */
      (gets = null) => getWorkerUrlWithParameters(
        'workers|employee|position|held-list',
        'list',
        null,
        gets
      ),
    UPDATE:
      /**
       * Обновляет информацию о сотруднике
       * @param {string|number} id - идентификатор сотрудника
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для обновления информации о сотруднике
       */
      (id, gets = null) => getWorkerUrlWithParameters(
        'workers|employee|worker|profile|self-detail',
        'update',
        { id },
        gets
      ),
    ORGANIZATION:
      /**
       * Получает список организаций
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения списка организаций
       */
      (gets = null) => getWorkerUrlWithParameters(
        'users|department|organization-list',
        'list',
        null,
        gets
      ),
    ORGANIZATION_TREE:
      /**
       * Получает дерево организации
       * @param {string|number} organization_id - идентификатор организации
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения дерева организации
       */
      (organization_id, gets = null) => getWorkerUrlWithParameters(
        'users|department|organization|department-tree',
        'tree',
        { organization_id },
        gets
      )
  }
}
